import Loader from "react-loader-spinner";
import { Search, CheckLg } from 'react-bootstrap-icons';
import { Table, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups4Select } from '../store/api/GetAllProduct';
import { useRef} from "react";
import { setSelectProductGroupPop } from "../store/api/Modals";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalSelectProductGroup = () => {
    const selectedItems = useRef([]);
    const name4Search = useRef();
    const pop = useSelector(state => state.popup.popSelectPropductGroup);
    const { show, onSelect } = pop;
    const groupList = useSelector(state => state.ProductReducer.productGroupSelectList);
    const dispatch = useDispatch();

    const close = () => {
        selectedItems.current = [];
        dispatch(setSelectProductGroupPop({ show: false }));
    }
    const search = () => {
        dispatch(getProductGroups4Select(name4Search.current.value));
    }
    const setSelectedItems = (add, item) => {
        selectedItems.current = [item];
        // if (add) {
        //     selectedItems.current.push(item);

        // }
        // else {
        //     let indx = selectedItems.current.indexOf(item);
        //     selectedItems.current.splice(indx, 1);
        // }
    }
    const select = () => {
        const array = selectedItems.current.slice();
        selectedItems.current = [];
        if (onSelect) {
            onSelect(array);
            dispatch(setSelectProductGroupPop({ show: false }));
        }
    }
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
             <span> <FontAwesomeIcon icon={faListAlt} size="lg"/>&nbsp; انتخاب گروه کالا</span>  
             <FontAwesomeIcon icon={faTimes} size="lg" onClick={close}/></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group col-md-8">
                    <input type="text" className="form-control" ref={name4Search} />
                    <Button className="btn-input-tiny" style={{top:"2px", left:"2px"}} onClick={search}><Search size="22"/></Button>
                </div>
                <Table responsive className="fixedTable mt-2">
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>&nbsp;</th>
                            <th style={{ width: "45%" }}>گروه اصلی</th>
                            <th style={{ width: "45%" }}>گروه فرعی</th>

                        </tr>
                    </thead>
                    <tbody>
                        {(groupList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width:"100%" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {groupList && Array.isArray(groupList) &&
                            groupList.map((item, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "10%", verticalAlign: "middle" }}>
                                        <input type="radio" className="form-check-input" name="radioProductGroup" onChange={(e) => setSelectedItems(e.target.checked, item)} />
                                    </td>
                                    <td style={{ width: "45%" }}>{item.MainGroupName}</td>
                                    <td style={{ width: "45%" }}>{item.GroupName}</td>

                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Button variant="info" className="group-Btn" onClick={select}><CheckLg />&nbsp;انتخاب گروه</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectProductGroup;